<template>
    <a :class="buttonType" class="btn hover:text-white w-40"  v-on:click.prevent="addOrRemove" href="#">
        <span>{{ button_text }}</span>
    </a>
</template>
<script>
    import { bus } from '../app';
    export default {
        name: "CartButton",
        props: {
            inline: Boolean,
            productId: String,
            cart: Boolean,
            buttonType: String,
        },
        data() {
            return {
                button_text: 'ADD TO CART',
                state: store.state,
                inCart: false,
                axios: window.axios,
            }
        },

        mounted() {
            if (this.inline || this.cart) {
                $(this.$el).attr('style-size', 'inline');
            }

            this.update();
        },

        methods: {
            update: function () {
                if(this.stateInCart() && this.belongsToState(this.productId)){
                    this.disableCountyButtons();
                }

                this.inCart = this.state.cart.indexOf(this.productId) !== -1;
                if (this.inCart) {
                    this.button_text = "REMOVE";
                    $(this.$el).attr("style-color", 'white');
                } else {
                    this.button_text = "ADD TO CART";
                    $(this.$el).removeAttr('style-color');
                }
            },
            addOrRemove: function () {
                if (this.inCart) {
                    this.remove();
                }
                else if(this.isNumeric(this.productId)){
                    this.checkIfStateOrCountyInCart(this.productId);
                }
                else {
                    this.add();
                }
            },
            add: function () {
                if(this.isState(this.productId)){
                    this.disableCountyButtons();
                }

                let component = this;
                store.addCartItemAction(this.productId);
                this.axios.put('/store/cart/' + this.productId)
                    .then(function () {
                        component.update();
                    });
            },
            remove: function () {
                if(this.isState(this.productId)){
                    this.enableCountyButtons();
                } else if(this.stateInCart() && this.belongsToState(this.productId)) {
                    this.$el.disabled = true;
                }
                let component = this;
                if (!component.cart) {
                    store.removeCartItemAction(this.productId);
                }
                this.axios.delete('/store/cart/' + this.productId)
                    .then(function () {
                        if (component.cart) {
                            location.reload();
                        }
                        component.update();
                    });
            },
            isNumeric: function(productId) {
                return /^[0-9]+$/.test(productId);
            },
            belongsToState: function(productId) {
                let belongsToState = false;
                //if a county id length is less than five, it must belong to a state with id less than 10
                let countyIdForSingleDigitState = this.countyIdForSingleDigitState(productId);

                //verify if state in the cart has county with correct id length
                if(countyIdForSingleDigitState){
                    this.state.cart.forEach(
                        value => {
                            if(this.isSingleDigitState(value) && productId.startsWith(value)){
                                belongsToState = true;
                            }
                        })
                } else {
                    this.state.cart.forEach(
                        value => {
                            if(this.isDoubleDigitState(value) && productId.startsWith(value)){
                                belongsToState = true;
                            }
                        })
                }
                return belongsToState;
            },
            hasCounty: function(productId) {
                let hasCounty = false;

                //check to see if county id belonging to single digit state id in cart, otherwise check for double digit state and county id
                if(productId < 10) {
                    this.state.cart.forEach(
                        value => {
                            if(this.countyIdForSingleDigitState(value) && value.startsWith(productId)){
                                hasCounty = true;
                            }
                        })
                } else{
                    hasCounty = this.state.cart.findIndex(value => value.startsWith(productId)) !== -1;
                }
                return hasCounty;
            },
            isSingleDigitState: function(stateId) {
                return stateId < 10;
            },
            isDoubleDigitState: function(stateId) {
                return stateId > 10 && stateId < 100;
            },
            countyIdForSingleDigitState: function(val) {
                return val.length < 5 && val.length > 2;
            },
            checkIfStateOrCountyInCart: function(productId) {
                if(this.isState(productId)) {
                    this.hasCounty(productId) ? bus.$emit('showStateModal', this.productId) : this.add(productId);
                } else {
                    this.belongsToState(productId) ? bus.$emit('showCountyModal', this.productId) : this.add(productId);
                }
            },
            isState: function(productId) {
                return (productId >= 0 && productId < 100);
            },
            stateInCart: function() {
                 return this.state.cart.some(value => this.isState(value));
            },
            disableCountyButtons: function() {
                let buttons = document.getElementsByClassName('county-button');
                for(let i = 0; i < buttons.length; i++){
                   if(buttons[i].innerHTML !== 'Remove') {
                       buttons[i].disabled = true;
                   }
                }
            },
            enableCountyButtons: function() {
                let buttons = document.getElementsByClassName('county-button');
                for(let i = 0; i < buttons.length; i++){
                    buttons[i].disabled = false;
                }
            },
        },
        created() {
            bus.$on('agree', (id) => {
                if(id === this.productId)
                    this.add()
            });

        },
    }
</script>

<style scoped>

</style>
